import { render, staticRenderFns } from "./ToggleAvg.vue?vue&type=template&id=358aefde&scoped=true&"
import script from "./ToggleAvg.vue?vue&type=script&lang=ts&"
export * from "./ToggleAvg.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleAvg.vue?vue&type=style&index=0&id=358aefde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358aefde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358aefde')) {
      api.createRecord('358aefde', component.options)
    } else {
      api.reload('358aefde', component.options)
    }
    module.hot.accept("./ToggleAvg.vue?vue&type=template&id=358aefde&scoped=true&", function () {
      api.rerender('358aefde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToggleAvg.vue"
export default component.exports